<a class="prev" title="Previo" (click)="retrocederAlbaran()">
  <img class="svg" src="assets/img/active-arrow.svg" alt="Previo">
</a>
